/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdEmployeeDataQueryResponse,
  GetApiV1PersonIdEmployeeDataPathParams,
  GetApiV1PersonIdEmployeeData401,
  GetApiV1PersonIdEmployeeData404,
  GetApiV1PersonIdEmployeeData500,
} from "../../types/personEmployeeController/GetApiV1PersonIdEmployeeData.ts";

function getGetApiV1PersonIdEmployeeDataUrl(
  id: GetApiV1PersonIdEmployeeDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/employee-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados da aba Employee da pessoa (cargo, crachá, admissão, demissão, tipo e notificação de chamado). **(Requer Authorization para autenticação)**
 * @summary Obter dados de funcionário (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/employee-data}
 */
export async function getApiV1PersonIdEmployeeData(
  id: GetApiV1PersonIdEmployeeDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdEmployeeDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdEmployeeData401
      | GetApiV1PersonIdEmployeeData404
      | GetApiV1PersonIdEmployeeData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdEmployeeDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
